(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heritage-article-reader"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('heritage-article-reader')) {
    customElements.define('heritage-article-reader', class extends HTMLElement {
      connectedCallback() {
        const toc = this.querySelector('[data-reader-toc]');
        const body = this.querySelector('[data-reader-body]');
        if (!toc || !body) return;

        const headings = body.querySelectorAll('h2');
        if (!headings.length) return;

        const list = toc.querySelector('[data-reader-toc-list]');
        list.replaceChildren();
        for (const [index, heading] of [...headings].entries()) {
          if (!heading.id) heading.id = `Article-${this.dataset.readerId}-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        }
        toc.hidden = false;
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.updateToc = () => { toc.open = this.desktopQuery.matches; };
        this.updateToc();
        this.desktopQuery.addEventListener('change', this.updateToc);
      }

      disconnectedCallback() {
        this.desktopQuery?.removeEventListener('change', this.updateToc);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-faq-page-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('heritage-faq-search')) {
    customElements.define('heritage-faq-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search]');
        this.filters = [...this.querySelectorAll('[data-faq-filter]')];
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.output = this.querySelector('[data-faq-status]');
        this.empty = this.querySelector('[data-faq-empty]');
        this.active = 'all';
        this.onInput = () => this.update();
        this.onFilter = (event) => {
          event.preventDefault();
          this.active = event.currentTarget.dataset.faqFilter;
          for (const link of this.filters) {
            const selected = link.dataset.faqFilter === this.active;
            link.classList.toggle('is-active', selected);
            if (selected) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          }
          this.update();
        };
        this.input?.addEventListener('input', this.onInput);
        for (const link of this.filters) link.addEventListener('click', this.onFilter);
        this.classList.add('is-ready');
        this.update();
      }
      disconnectedCallback() {
        this.input?.removeEventListener('input', this.onInput);
        for (const link of this.filters || []) link.removeEventListener('click', this.onFilter);
      }
      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
      }
      update() {
        const query = this.normalize(this.input?.value || '');
        let visible = 0;
        for (const group of this.groups) {
          let groupVisible = 0;
          const categoryMatches = this.active === 'all' || group.dataset.faqGroup === this.active;
          for (const item of group.querySelectorAll('[data-faq-item]')) {
            const matches = categoryMatches && this.normalize(item.textContent).includes(query);
            item.hidden = !matches;
            if (matches) groupVisible += 1;
          }
          group.hidden = groupVisible === 0;
          visible += groupVisible;
        }
        if (this.output) this.output.textContent = `${visible} ${visible > 1 ? 'réponses' : 'réponse'}`;
        if (this.empty) this.empty.hidden = visible !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('heritage-hero-benefits')) {
    class HeritageHeroBenefits extends HTMLElement {
      #controller = new AbortController();
      #timer = null;
      #scrollFrame = null;
      #index = 0;
      #track;
      #slides = [];
      #dots = [];
      #mobileQuery = window.matchMedia('(max-width: 989px)');
      #reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      connectedCallback() {
        this.#track = this.querySelector('[data-benefits-track]');
        this.#slides = [...this.querySelectorAll('[data-benefit-slide]')];
        this.#dots = [...this.querySelectorAll('[data-benefit-dot]')];

        if (!this.#track || this.#slides.length < 2) return;

        const { signal } = this.#controller;

        for (const dot of this.#dots) {
          dot.addEventListener('click', () => {
            this.#goTo(Number(dot.dataset.benefitDot));
            this.#restart();
          }, { signal });
        }

        this.#track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.#scrollFrame);
          this.#scrollFrame = requestAnimationFrame(() => this.#syncFromScroll());
        }, { passive: true, signal });

        this.#track.addEventListener('mouseenter', () => this.#stop(false), { signal });
        this.#track.addEventListener('mouseleave', () => this.#start(), { signal });
        this.#track.addEventListener('focusin', () => this.#stop(true), { signal });
        this.#track.addEventListener('focusout', () => this.#start(), { signal });
        this.#track.addEventListener('pointerdown', () => this.#stop(false), { passive: true, signal });
        this.#track.addEventListener('pointerup', () => this.#start(), { passive: true, signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.#stop(false);
          } else {
            this.#start();
          }
        }, { signal });

        this.#mobileQuery.addEventListener('change', () => this.#setup(), { signal });
        this.#reducedMotionQuery.addEventListener('change', () => this.#setup(), { signal });
        this.#setup();
      }

      disconnectedCallback() {
        this.#stop(false);
        cancelAnimationFrame(this.#scrollFrame);
        this.#controller.abort();
      }

      #setup() {
        this.#stop(false);

        if (!this.#mobileQuery.matches) {
          this.#track.removeAttribute('aria-live');
          for (const slide of this.#slides) slide.removeAttribute('aria-hidden');
          return;
        }

        this.#sync(this.#index);
        this.#start();
      }

      #canAutoplay() {
        return this.dataset.autoplay === 'true'
          && this.#mobileQuery.matches
          && !this.#reducedMotionQuery.matches
          && !document.hidden;
      }

      #start() {
        this.#stop(false);
        if (!this.#canAutoplay()) return;

        const requestedSpeed = Number(this.dataset.speed) || 5000;
        const speed = Math.max(requestedSpeed, 5000);
        this.#track.setAttribute('aria-live', 'off');
        this.#timer = window.setInterval(() => {
          this.#goTo((this.#index + 1) % this.#slides.length);
        }, speed);
      }

      #restart() {
        this.#stop(false);
        this.#start();
      }

      #stop(announce) {
        if (this.#timer) window.clearInterval(this.#timer);
        this.#timer = null;
        if (this.#mobileQuery.matches) {
          this.#track.setAttribute('aria-live', announce ? 'polite' : 'off');
        }
      }

      #goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.#slides.length - 1));
        const behavior = this.#reducedMotionQuery.matches ? 'auto' : 'smooth';
        this.#sync(nextIndex);
        this.#track.scrollTo({ left: this.#slides[nextIndex].offsetLeft, behavior });
      }

      #syncFromScroll() {
        if (!this.#mobileQuery.matches || !this.#track.clientWidth) return;
        const index = Math.round(this.#track.scrollLeft / this.#track.clientWidth);
        this.#sync(Math.max(0, Math.min(index, this.#slides.length - 1)));
      }

      #sync(index) {
        this.#index = index;

        for (const [slideIndex, slide] of this.#slides.entries()) {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        }

        for (const [dotIndex, dot] of this.#dots.entries()) {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        }
      }

    }

    customElements.define('heritage-hero-benefits', HeritageHeroBenefits);
  }

  } catch(e) { console.error(e); }
})();
})();
